import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/store";
import { cancelTimer, expireTicket } from "src/store/slices/timer/timer.slice";
import { expireStoredSession } from "src/utility";
import { useTranslation } from "react-i18next";
import { FailBannerIcon } from "src/assets/Icons";
import { Button } from "antd";
import { useLazyGetOrderDetailsQuery } from "src/store/slices/flights/Flights";
import { OrderStatus } from "src/Modules/UserHistory/constants/OrdersList";
import { pollDriver } from "./utils";
import PostbookLoader from "./components/PostbookLoader/PostbookLoader";
import JourneyResultNewWeb from "./layouts/JourneyResultNew.web";

function Failed() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-2);
  };
  return (
    <div className="h-100 flex w-full items-center justify-center">
      <div className="w-150 flex flex-col items-center justify-center gap-2 p-4">
        <div>
          <FailBannerIcon className="text-font-danger" />
        </div>
        <div>{t("Flights.result.ticketIssuanceFailed")}</div>
        <div className="flex items-center justify-between gap-3">
          <Button className="bg-background-primary! text-font-inverted! p-5! font-inter!" onClick={handleBack}>
            {t("Flights.result.searchAnotherFlight")}
          </Button>
          <Button className="p-5! font-inter!">{t("Flights.result.contactSupport")}</Button>
        </div>
      </div>
    </div>
  );
}

export default function JourneyResult() {
  const { ticketId } = useParams();
  const searchFormInputJSON = localStorage.getItem(ticketId ?? "");
  const everySaved = useMemo(() => (searchFormInputJSON ? JSON.parse(searchFormInputJSON) : null), [ticketId]);
  const orderId = everySaved?.orderId;
  const [getOrderDetails, { data: orderDetailsRes, isError }] = useLazyGetOrderDetailsQuery();
  const [finalStatus, setFinalStatus] = useState<number>()
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const endSession = () => {
      dispatch(cancelTimer());
      dispatch(expireTicket());
      expireStoredSession(ticketId);
    };

    const pollOrderStatus = () => {
      if (!orderId) return;
      pollDriver({
        functionToPoll: () => getOrderDetails({ referenceNumber: orderId }).unwrap(),
        shouldStop: (result) => result?.status !== OrderStatus.Pending,
      })
        .then((result) => setFinalStatus(result?.status ?? OrderStatus.Failed))
        .catch(() => setFinalStatus(OrderStatus.Failed));
    };

    endSession();
    pollOrderStatus();
  }, []);

  const isPolling = !!orderId && finalStatus === undefined;

  if (isPolling) return <PostbookLoader/>;

  if (isError || !orderDetailsRes) return <Failed />;

  return <JourneyResultNewWeb orderDetails={orderDetailsRes} />;
}
